// For get platform settings
export const GET_ADMIN_PLATFORM_SETTNGS = "GET_ADMIN_PLATFORM_SETTNGS"
export const GET_ADMIN_PLATFORM_SETTNGS_SUCCESS = "GET_ADMIN_PLATFORM_SETTNGS_SUCCESS"
export const GET_ADMIN_PLATFORM_SETTNGS_ERROR = "GET_ADMIN_PLATFORM_SETTNGS_ERROR"

export const UPDATE_ADMIN_PLATFORM_SETTNGS = "UPDATE_ADMIN_PLATFORM_SETTNGS"
export const UPDATE_ADMIN_PLATFORM_SETTNGS_SUCCESS = "UPDATE_ADMIN_PLATFORM_SETTNGS_SUCCESS"
export const UPDATE_ADMIN_PLATFORM_SETTNGS_ERROR = "UPDATE_ADMIN_PLATFORM_SETTNGS_ERROR"